/**
 * Helper function to format percentage values
 */
export const formatPercentageValue = (value: string): string => {
  if (!value || value === '') return '';
  
  // Remove existing % symbol if present
  let numericValue = value.replace('%', '').trim();
  
  // If empty after removing %, return empty
  if (!numericValue) return '';
  
  // Parse and validate the number
  const parsed = parseFloat(numericValue);
  if (isNaN(parsed)) return value; // Return original if invalid
  
  // Format to 2 decimal places and add % symbol
  return `${parsed.toFixed(2)}%`;
};

/**
 * Helper function to format KCPH values
 */
export const formatKCPHValue = (value: string): string => {
  if (!value || value === '') return '';
  
  // Remove any special characters except decimal point
  let numericValue = value.replace(/[^0-9.]/g, '').trim();
  
  // If empty after cleaning, return empty
  if (!numericValue) return '';
  
  // Parse and validate the number
  const parsed = parseFloat(numericValue);
  if (isNaN(parsed)) return value; // Return original if invalid
  
  // Format to 2 decimal places without % symbol
  return parsed.toFixed(2);
};